import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { FirestoreService } from 'src/app/services/firestore.service';

@Component({
  selector: 'app-government-territory-list',
  templateUrl: './government-territory-list.component.html',
  styleUrls: ['./government-territory-list.component.sass']
})
export class GovernmentTerritoryListComponent implements OnInit {
  items;
  colId;
  categoryName;
  territoryCol;
  logoImage: string = "./assets/img/no-logo.png"

  constructor(    
    private route: Router,
    private aroute: ActivatedRoute,
    public db: FirestoreService
  ) { }

  ngOnInit(): void {
    this.categoryName = this.aroute.snapshot.paramMap.get('id');
    this.territoryCol = this.db.getMainColOrder('governmentTerritories', 'priority')
    // console.log(this.categoryName)
  };

  // Route
  routeToGovernmentDetailPage(territoryName){
    this.route.navigateByUrl('governments/'+territoryName, { state: { category: this.categoryName, territory: territoryName} });
  };

}